import React from 'react';
import styled from '@emotion/styled';
import PageHeader from '../components/PageHeader';

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 2rem;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContentContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const Section = styled.div`
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 2rem;
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: white;
  
  .red {
    color: #ff3333;
  }
  
  .cloud {
    color: #ff3333;
  }
`;

const Text = styled.p`
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  color: rgba(255, 255, 255, 0.9);
  
  span {
    &.red {
      color: #ff3333;
    }
  }
`;

const FeatureList = styled.div`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1.1rem;
  line-height: 1.6;
  
  p {
    margin: 0.8rem 0;
    &::before {
      content: "•";
      color: #ff3333;
      margin-right: 0.8rem;
    }
  }
`;

function About() {
  return (
    <PageContainer>
      <ContentContainer>
        <PageHeader title="About RedCloud Storage" highlightWord="Cloud" />
        <Section>
          <Text>
            Founded in 2025, Red<span className="red">Cloud</span> Storage emerged from a vision to provide professionals with secure, reliable, and scalable cloud backup storage solutions. Our platform is built on the trusted Nextcloud technology, ensuring enterprise-grade security and reliability.
          </Text>
          <Text>
            We understand that data is the lifeline of modern businesses. That's why we've created a solution that not only protects your valuable information but also makes it easily accessible whenever you need it.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Our <span className="red">Mission</span></SectionTitle>
          <Text>
            To provide photographers, videographers, and content creators with secure, reliable, and user-friendly cloud backup storage solutions.
            Red<span className="red">Cloud</span> enables seamless collaboration and data management while ensuring the highest standards of privacy and security.
          </Text>
        </Section>

        <Section>
          <SectionTitle>Why Choose Red<span className="cloud">Cloud</span>?</SectionTitle>
          <FeatureList>
            <p>Enterprise-grade security protocols</p>
            <p>99.9% uptime guarantee</p>
            <p>24/7 technical support</p>
            <p>Scalable storage solutions</p>
            <p>User-friendly interface</p>
            <p>Regular backup options</p>
          </FeatureList>
        </Section>
      </ContentContainer>
    </PageContainer>
  );
}

export default About;
